var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',_vm._l((_setup.store.getters.form('migration')),function(migrationForm,key){return _c(_setup.FormHelper,{key:key,ref:"migrationForms",refInFor:true,attrs:{"config":{
        title: _vm.$t('salesChannelManagementApp.titles.migration.' + key),
        snippetPrefix: 'salesChannelManagementApp',
        validateOptions: true,

        loadingGroup: 'salesChannelManagementApp',
        ..._setup.labelData
      },"form":migrationForm},on:{"change":function($event){return _setup.onChangeMigrationForm($event, key)}},model:{value:(_setup.selectedIntegration.migration.value[key]),callback:function ($$v) {_vm.$set(_setup.selectedIntegration.migration.value, key, $$v)},expression:"selectedIntegration.migration.value[key]"}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }